import dotProp from 'dot-prop-immutable';
var defaultState = {
  "protected": {}
};
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case 'SET_APP_PROTECTED':
      return dotProp.set(state, 'protected', action["protected"]);
    default:
      return state;
  }
});